
export const songsdata = [
    {
        id: 1,
        title: "hey",
        img: "images/hey.jpg",
        audio: "music/hey.mp3"
    },
    {
        id: 2,
        title: "summer",
        img: "images/summer.jpg",
        audio: "music/summer.mp3"
    },
    {
        id: 3,
        title: "ukulele",
        img: "images/ukulele.jpg",
        audio: "music/ukulele.mp3"
    }
]